module.exports = __webpack_public_path__ + "b2ffe89f7e835cc3b78d819609121f42.svg";